export default {
  NumShopExposure: {
    event_code: "NumShopExposure",
    event_name: "页面曝光",
    event: "BtnClick",
  },
  NumShopSerchClick: {
    event_code: "NumShopSerchClick",
    event_name: "搜索条件标签点击",
    event: "BtnClick",
  },
  NumShopConsExposure: {
    event_code: "NumShopConsExposure",
    event_name: "产品详情页-我想了解弹框曝光",
    event: "BtnClick",
  },
  NumShopTryClick: {
    event_code: "NumShopTryClick",
    event_name: "产品详情页-试用弹框曝光",
    event: "BtnClick",
  },
  POSZSD0001: {
    event_code: "POSZSD0001",
    event_name: "数字商店首页曝光",
    event: "BtnClick",
  },
  POSZSD0005: {
    event_code: "POSZSD0005",
    event_name: "可定制化按钮点击",
    event: "BtnClick",
  },
  POSZSD0006: {
    event_code: "POSZSD0006",
    event_name: "顺丰精选按钮点击",
    event: "BtnClick",
  },
};
